import { useEffect, useRef } from 'react';

// ↑ ↑ ↓ ↓ ← → ← → b a
const KONAMI_SEQUENCE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
] as const;

/**
 * Fires `onTrigger` when the Konami code is entered anywhere on the page. Keeps a
 * rolling buffer of the last N keys so a partial-then-correct run still matches.
 * Comparison is case-insensitive on the final b/a.
 */
export function useKonami(onTrigger: () => void): void {
  const bufferRef = useRef<string[]>([]);
  const onTriggerRef = useRef(onTrigger);
  onTriggerRef.current = onTrigger;

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const key = event.key.length === 1 ? event.key.toLowerCase() : event.key;
      const buffer = [...bufferRef.current, key].slice(-KONAMI_SEQUENCE.length);
      bufferRef.current = buffer;
      if (
        buffer.length === KONAMI_SEQUENCE.length &&
        buffer.every((k, i) => k === KONAMI_SEQUENCE[i])
      ) {
        bufferRef.current = [];
        onTriggerRef.current();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
}
